import { Injectable } from '@angular/core';
import { interval, Subject, Subscription } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DisplayTimeService {
  private readonly minuteSubject = new Subject<number>();

  private subMinutes: Subscription | null = null;

  private intervalMinute$ = interval(60000);
  private elapsedMinutes = 0;

  public minute$() {
    return this.minuteSubject.asObservable().pipe(shareReplay(1));
  }

  public start(initialMinutes: number = 0): void {
    if (this.subMinutes) {
      this.stop();
    }

    this.elapsedMinutes = initialMinutes;

    this.subMinutes = this.intervalMinute$.subscribe(this.getMinutes);
  }

  private getMinutes = () => {
    this.elapsedMinutes++;
    this.minuteSubject.next(this.elapsedMinutes);
  };

  public stop(): void {
    if (this.subMinutes) {
      this.subMinutes.unsubscribe();
    }

    this.elapsedMinutes = 0;
  }
}
